import React, { useState } from "react";

import Select from "../alerts/select";
import Modal from "react-bootstrap/Modal";
import TextField from "@mui/material/TextField";
import Red_toast from "../alerts/red_toast";
import ApartmentIcon from "@material-ui/icons/Apartment";

import Update_button from "../buttons/update_button";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

function UpdatePaymentform({
  show,
  onHide,
  data,
  user,
  route,
  fun,
  callback,
  selected_branch,
  customers,
  salepersons,
  text,
  setloadagain,
}) {
  const { t } = useTranslation();
  const [party, setparty] = useState({
    value: data.party,
    label: data.party_name,
  });
  const [sale_person, setsale_person] = useState({
    value: data.sale_person,
    label: data.sale_person_name,
  });
  const [credit, setcredit] = useState(data.credit);
  const [debit, setdebit] = useState(data.debit);
  const [description, setdescription] = useState(data.remarks);

  const [isloading, setisloading] = useState(false);
  const [date, setdate] = useState(data.date);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selected_branch && !isloading) {
      setisloading(true);
      const formData = new FormData();

      formData.append("remarks", description);
      formData.append("credit", credit);
      formData.append("debit", debit);
      formData.append("party", party.value);
      formData.append("date", date);
      if (text === t("side_bar_customers")) {
        formData.append("sale_person", sale_person.value);
      }

      const response = await fetch(`${route}${data.id}/`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${user.access}`,
        },
        body: formData,
      });
      const json = await response.json();

      if (!response.ok) {
        setisloading(false);
        if (json.code === "token_not_valid") {
          callback({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }

      if (response.ok) {
        setisloading(false);
        callback({ type: "Update_table_history", data: json });
        onHide();
        fun("Update");
        setloadagain();
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ zoom: ".8" }}
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="d-flex align-items-md-center"
        >
          <ApartmentIcon className="me-2" />
          {t("edit_journal")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Select
                options={customers}
                placeholder={text}
                value={party}
                funct={(e) => {
                  setparty(e);
                }}
                required={true}
              ></Select>
            </div>
            <div className="col-md-6">
              <TextField
                type="date"
                className="form-control   mb-3"
                label={t("date")}
                value={date}
                onChange={(e) => setdate(e.target.value)}
                size="small"
              />
            </div>
            {text === t("side_bar_customers") && (
              <div className="col-md-6">
                <Select
                  options={salepersons}
                  placeholder={t("saleman")}
                  value={sale_person}
                  funct={(e) => {
                    setsale_person(e);
                  }}
                  required={true}
                ></Select>
              </div>
            )}
            <div className="col-md-6">
              <TextField
                type="number"
                className="form-control  mb-3"
                label={t("credit")}
                value={credit}
                onChange={(e) => setcredit(e.target.value)}
                size="small"
                required
              />
            </div>
            <div className="col-md-6">
              <TextField
                type="number"
                className="form-control  mb-3"
                label={t("debit")}
                value={debit}
                onChange={(e) => setdebit(e.target.value)}
                size="small"
                required
              />
            </div>

            <div className="col-md-6">
              <TextField
                multiline
                className="form-control   mb-3"
                label={t("remarks")}
                value={description}
                onChange={(e) => setdescription(e.target.value)}
                size="small"
              />
            </div>
          </div>

          <hr></hr>
          <div className=" d-flex flex-row-reverse mt-2 me-2">
            <Update_button isloading={isloading} />
          </div>
        </form>
        <ToastContainer autoClose={5000} hideProgressBar={true} theme="dark" />
      </Modal.Body>
    </Modal>
  );
}

export default UpdatePaymentform;
